/* eslint-disable max-len */

import React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

function Notifications(props: SvgIconProps): React.ReactElement {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <path
        d="M-3853-512h4a2,2,0,0,1-2,2A2,2,0,0,1-3853-512Zm-3-1h-3a1,1,0,0,1-1-1,1,1,0,0,1,1-1h1v-7a7.01,7.01,0,0,1,6-6.929V-530a1,1,0,0,1,1-1,1,1,0,0,1,1,1v1.072a7.011,7.011,0,0,1,6,6.929v7h1a1,1,0,0,1,1,1,1,1,0,0,1-1,1h-13Zm10-2v-7a5.005,5.005,0,0,0-5-5,5.006,5.006,0,0,0-5,5v7Z"
        transform="translate(3863 532)"
      />
    </SvgIcon>
  );
}

export default Notifications;
